import React from "react";
import { Link } from "react-router-dom";

export const MARKETING_OPT_IN_TEXT =
  "Yes, send me service reminders, special offers and promotions from NQ Springs by email. I can unsubscribe at any time.";

/** Optional, unticked by default. Never required to send a form. */
export function MarketingOptIn({ checked, onChange, id = "marketing-opt-in", className = "" }) {
  return (
    <label
      htmlFor={id}
      className={`flex cursor-pointer items-start gap-2.5 text-xs leading-relaxed text-[color:var(--nq-stone)] ${className}`}
      data-testid={`${id}-label`}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 accent-[color:var(--nq-gold)]"
        data-testid={`${id}-checkbox`}
      />
      <span>
        {MARKETING_OPT_IN_TEXT}{" "}
        <Link to="/privacy-policy" target="_blank" className="gold-text font-semibold" data-testid={`${id}-privacy-link`}>
          Privacy Policy
        </Link>
      </span>
    </label>
  );
}

export const OPT_IN_NEEDS_EMAIL = "Add your email address to receive offers, or untick the box.";
